import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import { useOverlayItem } from '@flipster/overlay';
import { Spinner } from '@flipster/react/design-system';
import { Modal } from '@flipster/react/design-system-legacy/modal';
import { createStepComponent } from '@flipster/react/misc/step/Steps';
import { useSteps } from '@flipster/react/misc/step/use-steps';
import { center } from '@flipster/styled-system/patterns';

import DepositGuide from './DepositGuide';
import Form from './Form';
import Preview from './Preview';
import { mintBunja } from './state';

type Steps = {
  init: undefined;
  depositGuide: undefined;
  form: undefined;
  preview: undefined;
};

const Steps = createStepComponent<Steps>();

const MintFlowModal = () => {
  const { onClose } = useOverlayItem();
  const { current, push } = useSteps<Steps>({
    initialValue: {
      step: 'init',
      context: undefined,
    },
  });

  const { isLoadingAtom, needToDepositMoreAtom } = useBunja(mintBunja);
  const isLoading = useAtomValue(isLoadingAtom);
  const needToDepositMore = useAtomValue(needToDepositMoreAtom);

  useEffect(() => {
    if (!isLoading) {
      push({ step: needToDepositMore ? 'depositGuide' : 'form', context: undefined });
    }
  }, [isLoading, push, needToDepositMore]);

  return (
    <Modal>
      <Modal.Close onClose={onClose} />
      <Steps model={current}>
        <Steps.Step step='init'>
          {() => (
            <div className={center({ minH: 500 })}>
              <Spinner />
            </div>
          )}
        </Steps.Step>
        <Steps.Step step='depositGuide'>{() => <DepositGuide />}</Steps.Step>
        <Steps.Step step='form'>
          {() => <Form onPreview={() => push({ step: 'preview', context: undefined })} />}
        </Steps.Step>
        <Steps.Step step='preview'>{() => <Preview onConfirm={() => onClose()} />}</Steps.Step>
      </Steps>
    </Modal>
  );
};

export default MintFlowModal;
